import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import additionalDataFactory from './common/fieldsAdditionalData';
import fieldsContact from './common/fieldsContact';

import {
    fieldsShoesStoragesDimension,
    fieldsShoesStoragesMaterial,
    fieldsShoesStoragesQuantity,
    fieldsShoesStoragesShoesQuantity,
} from './common/fieldsShoesStorages';

const ShelfShoesForm: IForm = {
    formId       : PublishedFormId.ShelfShoes,
    type         : FormTypeId.Storage,
    thumbnailURL : '/resized-images/forms/shelf-shoes.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.Material,
        IFormFieldKey.SecondMaterial,
        IFormFieldKey.ShoesQuantity,
        IFormFieldKey.Quantity,
        IFormFieldKey.Dimension,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        material       : fieldsShoesStoragesMaterial,
        secondMaterial : fieldsShoesStoragesMaterial,
        shoesQuantity  : fieldsShoesStoragesShoesQuantity,
        quantity       : fieldsShoesStoragesQuantity,
        dimension      : fieldsShoesStoragesDimension,
        additionalData : additionalDataFactory({
            budgetMin          : 500,
            budgetMax          : 5000,
            budgetDefaultValue : 1500,
        }),
        contact: fieldsContact,
    },
};

export default ShelfShoesForm;
